export const APP_STARTED = "application/APP_STARTED";
export const APP_ERROR = "application/APP_ERROR";
export const APP_DATA_LOADED = "application/APP_DATA_LOADED";

export const appError = error => ({ type: APP_ERROR, error });
export const appDataLoaded = data => ({ type: APP_DATA_LOADED, data });
